<template>
  <div id="add_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" v-if="formParam.header.id != '' && formParam.header.id != null">
            Edit Pesan Balas Otomatis
          </h5>
          <h5 class="modal-title" v-else>Tambah Pesan Balas Otomatis</h5>
          <!-- {{formParam}} -->
          <button ref="dismisModal" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
            <li class="nav-item">
              <a
                @click="settabMessage('setup')"
                :class="(tabMessage=='setup')?'nav-link active':'nav-link' "
                href="#form"
                data-toggle="tab"
              >Setup Message</a>
            </li>
            <li class="nav-item">
              <a
                @click="savePreview;settabMessage('preview')"
                :class="(tabMessage=='preview')?'nav-link active':'nav-link' "
                href="#preview"
                data-toggle="tab"
              >Preview Message</a>
            </li>
          </ul>-->
          <!-- {{ aiBalance }} -->
          <div class="tab-content">
            <div :class="tabMessage == 'setup' ? 'tab-pane show active' : 'tab-pane'
              " id="form">
              <div class="row">
                <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                  <ul class="nav float-right custom-menu">
                    <li class="dropdown dropdown-action">
                      <a href class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                        <i class="material-icons">more_vert</i>
                      </a>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a @click.prevent="tourShow" class="dropdown-item" href="javascript:void(0)">Tour Guide</a>
                        <a target="_blank" class="dropdown-item"
                          href="https://www.youtube.com/watch?v=9h84laHdtCE&ab_channel=waajoindonesia">Tutorial
                          Video</a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>
                          Select License:
                          <span class="text-danger">*</span>
                        </label>
                        <!-- {{selectedLicense}} -->
                        <div class="input-group m-b-30">
                          <multiselect data-tour-step="formsar.1" :class="' '" v-model="selectedLicense" id="ajax"
                            label="license_name" track-by="id" :placeholder="typeof selectedLicense != 'undefined' &&
                              typeof selectedLicense.license_name != 'undefined'
                              ? selectedLicense.license_name
                              : ''
                              " open-direction="bottom" :custom-label="customLabelLicense" :options="licenseOptions"
                            :multiple="true" :searchable="true" :loading="isLoadingLicense" :internal-search="false"
                            :close-on-select="false" :options-limit="300" :limit="3" :limit-text="limitText"
                            :max-height="600" :show-no-results="true" :hide-selected="true"
                            @search-change="asyncFindLicenseSelect" :show-labels="false">
                            <template slot="option" slot-scope="{ option, remove }">
                              <span>{{
                                option.license_name +
                                " (" +
                                option.license_phone_number +
                                ")"
                              }}
                                <i :class="{
                                  'text-success': option.is_online_status == 1,
                                  'text-danger': option.is_online_status == 0,
                                }" :title="option.is_online_status == 1 ? 'Online' : 'Offline'"
                                  class="fa fa-signal"></i>
                              </span>
                            </template>
                            <template slot="tag" slot-scope="{ option, remove }">
                              <span class="custom__tag">
                                <span>{{
                                  option.license_name +
                                  " (" +
                                  option.license_phone_number +
                                  ")"
                                }}
                                  <i :class="{
                                    'text-success': option.is_online_status == 1,
                                    'text-danger': option.is_online_status == 0,
                                  }" :title="option.is_online_status == 1 ? 'Online' : 'Offline'"
                                    class="fa fa-signal"></i>
                                </span>
                                <span class="custom__remove" @click="remove(option)">❌</span>
                              </span>
                            </template>
                            <template slot="clear" slot-scope="props">
                              <div class="multiselect__clear" v-if="
                                typeof selectedLicense.length !=
                                'undefined' && selectedLicense.length
                              " @mousedown.prevent.stop="
                                clearAllLicense(props.search)
                                "></div>
                            </template>
                            <span slot="noResult">Oops! No elements found.</span>
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12" v-show="false">
                      <div class="form-group">
                        <label>Trigger fires on</label>
                        <div class="col-lg-9">
                          <div class="form-check form-check-inline">
                            <input data-tour-step="formsar.2" class="form-check-input" type="radio"
                              v-model="formParam.header.trigger_on" id="all" value="all" />
                            <label class="form-check-label" for="all">All Incoming Chats</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input data-tour-step="formsar.3" v-model="formParam.header.trigger_on"
                              class="form-check-input" type="radio" id="some" value="some" />
                            <label class="form-check-label" for="some">Some Chats</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12" v-if="formParam.header.trigger_on == 'some'">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <span class="text-muted">Include people who meet</span>
                              <select v-model="formParam.header.trigger_on_some_type" style="width: 100px">
                                <option :value="'any'">Any</option>
                                <option :value="'all'">All</option>
                              </select>
                              <span class="text-muted">of the following conditions</span>
                            </div>
                          </div>
                        </div>
                        <div class="row" v-for="(rowSome, indxSome) in formParam.detail_some" :key="indxSome">
                          <div class="col-md-3">
                            <div class="form-group form-focus select-focus">
                              <select v-model="rowSome.select_variable" style="width: 100%">
                                <option :value="'conversation'">
                                  Conversation Text
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group form-focus select-focus">
                              <select v-model="rowSome.condition" style="width: 100%">
                                <option :value="''">
                                  --Select Condition--
                                </option>
                                <template v-for="(rowCon, idxCon) in someConditions">
                                  <option :value="rowCon.value" :key="idxCon">
                                    {{ rowCon.label }}
                                  </option>
                                </template>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-5">
                            <input v-model="rowSome.text" placeholder="Eq: Hello..." type="text" style="width: 100%" />
                          </div>
                          <div class="col-md-1">
                            <a v-if="
                              indxSome == 0 &&
                              formParam.detail_some.length == 1
                            " @click.prevent="addRow">
                              <i class="fa fa-plus"></i>
                            </a>
                            <template v-else-if="
                              indxSome > 0 &&
                              indxSome == formParam.detail_some.length - 1
                            ">
                              <a @click.prevent="addRow">
                                <i class="fa fa-plus"></i>
                              </a>
                              <a @click.prevent="
                                removeRow(
                                  indxSome,
                                  formParam.detail_some.length - 1
                                )
                                ">
                                <i class="fa fa-minus"></i>
                              </a>
                            </template>
                            <a v-else @click.prevent="
                              removeRow(
                                indxSome,
                                formParam.detail_some.length - 1
                              )
                              ">
                              <i class="fa fa-minus"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group form-focus select-focus">
                                <input v-model="formParam.header.title" placeholder="" type="text"
                                  class="form-control" />
                                <label class="focus-label">Title
                                  <span class="text-danger">*</span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-8 col-md-8">
                              <div class="row">
                                <div class="col-sm-12 col-md-12">
                                  <div class="form-group">
                                    <label>
                                      Respond Message:
                                      <span class="text-danger">*</span>
                                    </label>
                                    <chatComponent :showCountdown="true" data-tour-step="formsar.4"
                                      v-model="formParam.header.message" @input="countdown" />
                                    <!--
                                    <div class="message-bar">
                                      <div class="message-inner">
                                        <a class="link attach-icon" @click.prevent="emojiToggle()">
                                          <img style="width:30px;" src="@/assets/emoji.png" alt />
                                        </a>
                                        <div class="input-group m-b-30">
                                          <div class="input-group-prepend">
                                            <div class="dropdown dropdown-action">
                                              <a
                                                href="#"
                                                class="action-icon dropdown-toggle text-info"
                                                data-toggle="dropdown"
                                                aria-expanded="false"
                                              >
                                                <i class="material-icons">more_vert</i>
                                              </a>
                                              <div class="dropdown-menu dropdown-menu-right">
                                                <span style="margin:5px;">
                                                  <b>
                                                    <u>Template Message:</u>
                                                  </b>
                                                </span>
                                                <template v-for="temp in templateMessage">
                                                  <a
                                                    class="dropdown-item"
                                                    @click.prevent="addTemplateToMesage(temp)"
                                                    :key="temp"
                                                  >{{temp}}</a>
                                                </template>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="input-group-append">
                                            <Emoji
                                              :open="emojiAttr.open"
                                              :width="emojiAttr.width"
                                              :height="emojiAttr.height"
                                              searchLabel="Search emoji here"
                                              @click="selectedEmoji"
                                            />
                                          </div>
                                          <textarea
                                            v-on:keyup="countdown"
                                            data-tour-step="formsar.4"
                                            :style="'width:100%;height:200px'"
                                            ref="messagebox"
                                            v-model="formParam.header.message"
                                            :placeholder="'Type message...'"
                                            required
                                          ></textarea>
                                          <p
                                            class="text-right text-small"
                                            v-bind:class="{'text-danger': hasError }"
                                          >{{remainingCount}}</p>
                                        </div>
                                      </div>
                                    </div>
                                    -->
                                  </div>
                                </div>
                                <div class="col-sm-12 col-md-12">
                                  <div class="col-md-12" v-show="formParam.header.ai_status == false">
                                    <div class="form-group">
                                      <div class="row">
                                        <div class="col-md-4">
                                          <div class="form-group">
                                            <label data-tour-step="formsar.7">Attach Image/File</label>
                                          </div>
                                        </div>
                                        <div class="col-md-2">
                                          <div class="onoffswitch">
                                            <input @click="
                                              updateMessageTypeCurrent('')
                                              " type="checkbox" name="onoffswitch" v-model="formParam.header
                                                .is_enable_attach_file
                                                " class="onoffswitch-checkbox" id="is_enable_attach_file" />
                                            <label class="onoffswitch-label" for="is_enable_attach_file">
                                              <span class="onoffswitch-inner"></span>
                                              <span class="onoffswitch-switch"></span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-12" v-if="
                                    formParam.header.is_enable_attach_file ==
                                    true
                                  ">
                                    <div class="form-group">
                                      <table class="table table-active">
                                        <tr>
                                          <th class="text-right">Url File</th>
                                          <th style="width: 30%" class="text-left">
                                            <div class="onoffswitch">
                                              <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox"
                                                v-model="formParam.header.is_custom_url
                                                  " id="switch_url_file" />
                                              <label class="onoffswitch-label" for="switch_url_file">
                                                <span class="onoffswitch-inner"></span>
                                                <span class="onoffswitch-switch"></span>
                                              </label>
                                            </div>
                                          </th>
                                          <th class="text-center">
                                            <label>Select Message Type &amp; Upload
                                              File</label>
                                            <p v-if="
                                              formParam.header != '' &&
                                              formParam.header.image_url != ''
                                            ">
                                              <a v-if="
                                                formParam.header
                                                  .message_type == 'document'
                                              " target="_blank" :href="formParam.header.image_url
                                                ">
                                                <i class="fa fa-file"></i> File
                                              </a>
                                              <a v-if="
                                                formParam.header
                                                  .message_type == 'image'
                                              " target="_blank" :href="formParam.header.image_url
                                                ">
                                                <img :src="formParam.header.image_url
                                                  " style="width: 100px" />
                                              </a>
                                            </p>
                                            <button class="btn btn-outline-secondary dropdown-toggle" type="button"
                                              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                              v-if="uploadMessageType == ''">
                                              Options
                                            </button>
                                            <button :style="'margin:5px;'"
                                              class="btn btn-outline-secondary dropdown-toggle" type="button"
                                              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-else>
                                              {{ uploadMessageType }}
                                            </button>
                                            <div class="dropdown-menu">
                                              <a @click.prevent="
                                                updateMessageTypeCurrent(opt)
                                                " class="dropdown-item" href="#" v-for="(
opt, index
                                                ) in messageTypeOptionsUpload" :key="index">
                                                <i class="text-success fa fa-check-circle" v-if="
                                                  uploadMessageType == opt
                                                "></i>
                                                {{ opt }}
                                              </a>
                                            </div>
                                          </th>
                                        </tr>
                                      </table>

                                      <div v-show="files.length == 0 &&
                                        (formParam.header.is_custom_url ==
                                          false ||
                                          typeof formParam.header
                                            .is_custom_url == 'undefined')
                                        " class="col-md-12 upload-drop-zone" id="drop-zone">
                                        <center>
                                          <i class="fa fa-cloud-upload fa-2x"></i>
                                          <span class="upload-text">
                                            <label :for="name">
                                              Just drag and drop file here
                                            </label>
                                          </span>
                                        </center>
                                      </div>
                                      <div>
                                        <!-- <form id="js-upload-form"> -->

                                        <div class="col-md-12" v-if="
                                          formParam.header.is_custom_url ==
                                          true
                                        ">
                                          <div class="row">
                                            <div class="col-md-12">
                                              <div class="form-group">
                                                <label>Image / File URL</label>
                                                <input type="text" class="form-control" v-model="formParam.header.image_url
                                                  " />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-md-12" v-if="
                                          formParam.header.is_custom_url ==
                                          false
                                        ">
                                          <!-- {{files}} -->
                                          <!-- <h4 v-if="files.length">Uploading</h4> -->
                                          <ul class="upload-list" v-if="files.length">
                                            <li v-for="file in files" :key="file.id" class="file-list">
                                              <div class="upload-wrap">
                                                <div class="file-name">
                                                  <!-- <i class="fa fa-photo"></i> -->
                                                  <img style="width: 30px" v-if="file.thumb" :src="file.thumb" />
                                                  {{ file.name }}
                                                </div>
                                                <div class="file-size">
                                                  {{ formatSizes(file.size) }}
                                                </div>
                                                <div class="file-close">
                                                  <span class="text-danger" v-if="file.error">{{ file.error }}</span>
                                                  <span v-else-if="file.success">
                                                    <i class="text-success fa fa-check-circle"></i>
                                                  </span>
                                                  <span v-else-if="file.active">active</span>
                                                  <span v-else></span>

                                                  <a href="#" @click.prevent="
                                                    $refs.uploadbc.remove(
                                                      file
                                                    )
                                                    " class="text-warning">
                                                    <i class="fa fa-trash-o"></i>
                                                  </a>
                                                </div>
                                              </div>

                                              <div class="progress progress-xs progress-striped" v-if="
                                                file.active ||
                                                file.progress !== '0.00'
                                              ">
                                                <div class="progress-bar bg-success" role="progressbar" :style="{
                                                  width: file.progress + '%',
                                                }"></div>
                                              </div>
                                              <div class="upload-process" v-if="
                                                file.active ||
                                                file.progress !== '0.00'
                                              ">
                                                {{ file.progress }}% done
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                        <!-- </form> -->

                                        <div class="col-sm-12 col-md-12">
                                          <div class="alert alert-info">
                                            <ul style="
                                                overflow-x: scroll;
                                                overflow-y: hidden;
                                                white-space: nowrap;
                                              ">
                                              <li class="text-wrap">
                                                Support files: {{ extensions }}
                                              </li>
                                              <li>MaxSize: 10Mb</li>
                                            </ul>
                                          </div>
                                        </div>
                                        <div class="col-sm-12" v-show="$refs.uploadbc &&
                                          $refs.uploadbc.active == false &&
                                          formParam.header.is_custom_url ==
                                          false
                                          ">
                                          <div class="submit-section">
                                            <div class="input-group mb-3">
                                              <div class="input-group-prepend" v-show="false">
                                                <file-upload-bc :add-index="true" class="btn btn-outline-secondary"
                                                  :data="objFilesMessageHandler" :post-action="uploadUrl"
                                                  :multiple="false" :headers="headers" :drop="true"
                                                  :drop-directory="true" v-model="files" @input-filter="inputFilter"
                                                  @input-file="inputFile" ref="uploadbc" :maximum="maximumUpload"
                                                  :extensions="extensions">
                                                  <img src="@/assets/attachment.png" alt />
                                                </file-upload-bc>
                                              </div>

                                              <div class="input-group-append">
                                                <button v-if="false" @click.prevent="
                                                  $refs.uploadbc.active = true
                                                  " class="btn btn-outline-secondary" type="button">
                                                  Upload File
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="row" v-if="
                                          $refs.uploadbc &&
                                          $refs.uploadbc.active == true
                                        ">
                                          <div class="col-sm-2">
                                            <Skeleton :height="'40px'" :count="1" />
                                          </div>
                                          <div class="col-sm-2">
                                            <Skeleton :height="'40px'" :count="1" />
                                          </div>
                                          <div class="col-sm-6">
                                            <Skeleton :height="'40px'" :count="1" />
                                          </div>
                                          <div class="col-sm-2">
                                            <Skeleton :height="'40px'" :count="1" />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label class="text text-info" style="font-weight: bold"><i
                                              class="fa fa-magic"></i>
                                            AI</label>
                                        </div>
                                      </div>
                                      <div class="col-md-2">
                                        <div class="onoffswitch">
                                          <input @click="forceDisableAttachFile" type="checkbox" name="onoffswitch"
                                            class="onoffswitch-checkbox" v-model="formParam.header.ai_status"
                                            id="switch_ai_status" />
                                          <label class="onoffswitch-label" for="switch_ai_status">
                                            <span class="onoffswitch-inner"></span>
                                            <span class="onoffswitch-switch"></span>
                                          </label>
                                        </div>
                                      </div>
                                      <p class="text text-danger" v-if="aiBalance.is_available == false">
                                        Mode AI belum bisa digunakan, silakan
                                        kontak Tim Waajo atau cek Konfigurasi
                                        <router-link :to="'/ai-chat/overview'" :target="'_blank'">disini.</router-link>
                                      </p>
                                    </div>
                                  </div>
                                  <template v-show="formParam.header.ai_status == true">
                                    <div class="col-md-12" v-show="formParam.header.ai_status == true
                                      ">
                                      <div class="form-group">
                                        <label>Deskripsikan AI Anda (Prompt System)</label>
                                        <textarea class="form-control" ref="messagebox-prompt"
                                          :style="'min-height:100px;'" v-model="formParam.header.ai_prompt_system
                                            "
                                          :placeholder="'Misal: Kamu adalah asisten perusahaan. Jawab dengan profesional untuk pelanggan yang bertanya tentang produk/jasa.'"></textarea>
                                      </div>
                                    </div>
                                    <div class="col-md-12" v-show="formParam.header.ai_status == true
                                      ">
                                      <div class="form-group form-focus select-focus">
                                        <select v-model="formParam.header.ai_type" class="form-control">
                                          <option v-for="(row, idx) in aiTypeList" :key="idx" :value="row.value">
                                            {{ row.label }}
                                          </option>
                                        </select>
                                        <label class="focus-label">Mode AI</label>
                                      </div>
                                    </div>
                                    <div class="col-md-12" v-show="formParam.header.ai_status == true &&
                                      formParam.header.ai_type == 'summarize'
                                      ">
                                      <div class="alert alert-warning">
                                        <i class="fa fa-info-circle mr-1"></i>
                                        Kelola data melalui menu
                                        <router-link :to="'/ai/historykb'" target="_blank"
                                          class="font-weight-bold">Knowledge Base</router-link>.
                                        <br>
                                        <strong>⚠️ Penting:</strong> Pastikan file yang diunggah sudah relevan dengan
                                        lisensi yang Anda pilih agar sinkronisasi data berjalan lancar.
                                      </div>
                                    </div>
                                    <div class="col-md-12" v-show="false">
                                      <div class="form-group">
                                        <!-- filesExtract: {{ filesExtract }}
                                          <br />
                                          filesExtract: {{ filesExtract }} -->
                                        <ul class="upload-list" v-if="filesExtract.length">
                                          <li v-for="file in filesExtract" :key="file.id" class="file-list">
                                            <div class="upload-wrap">
                                              <div class="file-name">
                                                <!-- <i class="fa fa-photo"></i> -->
                                                <img style="width: 30px" v-if="file.thumb" :src="file.thumb" />
                                                {{ file.name }}
                                              </div>
                                              <div class="file-size">
                                                {{ formatSizes(file.size) }}
                                              </div>
                                              <div class="file-close">
                                                <span class="text-danger" v-if="file.error">{{ file.error }}</span>
                                                <span v-else-if="file.success">
                                                  <i class="text-success fa fa-check-circle"></i>
                                                </span>
                                                <span v-else-if="file.active">active</span>
                                                <span v-else></span>

                                                <a href="#" @click.prevent="
                                                  $refs.uploadbcExtract.remove(
                                                    file
                                                  )
                                                  " class="text-warning">
                                                  <i class="fa fa-trash-o"></i>
                                                </a>
                                              </div>
                                            </div>

                                            <div class="progress progress-xs progress-striped" v-if="
                                              file.active ||
                                              file.progress !== '0.00'
                                            ">
                                              <div class="progress-bar bg-success" role="progressbar" :style="{
                                                width: file.progress + '%',
                                              }"></div>
                                            </div>
                                            <div class="upload-process" v-if="
                                              file.active ||
                                              file.progress !== '0.00'
                                            ">
                                              {{ file.progress }}% done
                                            </div>
                                          </li>
                                        </ul>

                                        <file-upload-bc-extract class="btn btn-outline-secondary"
                                          :accept="acceptExtract" :data="objFilesMessageHandlerExtract"
                                          :post-action="uploadUrl" :multiple="false" :headers="headers" :drop="true"
                                          :drop-directory="true" v-model="filesExtract"
                                          @input-filter="inputFilterExtract" @input-file="inputFileExtract"
                                          ref="uploadbcExtract" :maximum="maximumUpload"
                                          :extensions="extensionsExtract">
                                          <i class="fa fa-plus"></i>
                                          Select File Knowledge Base
                                        </file-upload-bc-extract>
                                        <p class="text text-primary">
                                          <small>
                                            Support files:
                                            {{ extensionsExtract }} <br />Max
                                            Size: 10MB
                                          </small>
                                        </p>
                                        <div class="input-group-append" v-if="false">
                                          <button @click.prevent="
                                            $refs.uploadbcExtract.active = true
                                            " class="btn btn-outline-secondary" type="button">
                                            Upload File
                                          </button>
                                        </div>
                                      </div>
                                      <div class="form-group" v-show="false">
                                        <label>Input Knowledge Base</label>
                                        <textarea class="form-control" ref="messagebox-knowledge-base"
                                          :style="'min-height:200px;'" v-model="formParam.header.ai_summary"
                                          :placeholder="'Knowledge base...'"></textarea>
                                      </div>
                                    </div>
                                    <div class="col-md-12" v-show="formParam.header.ai_status == true
                                      ">
                                      <div class="form-group form-focus select-focus">
                                        <select v-model="formParam.header.ai_close_frequency
                                          " class="form-control">
                                          <option v-for="(
row, idx
                                            ) in frequencyCloseSessionList" :key="idx" :value="row.value">
                                            {{ row.label }}
                                          </option>
                                        </select>
                                        <label class="focus-label">Tutup Sesi Jika tidak ada interaksi
                                          selama</label>
                                      </div>
                                    </div>
                                    <div class="col-md-12" v-show="formParam.header.ai_status == true
                                      ">
                                      <div class="row">
                                        <div class="col-md-6">
                                          <div class="form-group">
                                            <label>Tampilkan Loading AI</label>
                                          </div>
                                        </div>
                                        <div class="col-md-2">
                                          <div class="onoffswitch">
                                            <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox"
                                              v-model="formParam.header.ai_loading
                                                " id="switch_ai_loading" />
                                            <label class="onoffswitch-label" for="switch_ai_loading">
                                              <span class="onoffswitch-inner"></span>
                                              <span class="onoffswitch-switch"></span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-12" v-show="formParam.header.ai_status == true
                                      ">
                                      <div class="row">
                                        <div class="col-md-6">
                                          <div class="form-group">
                                            <label>Buat Rangkuman Saat Sesi Selesai</label>
                                          </div>
                                        </div>
                                        <div class="col-md-2">
                                          <div class="onoffswitch">
                                            <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox"
                                              v-model="formParam.header.is_ai_create_summary
                                                " id="switch_is_ai_create_summary" />
                                            <label class="onoffswitch-label" for="switch_is_ai_create_summary">
                                              <span class="onoffswitch-inner"></span>
                                              <span class="onoffswitch-switch"></span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-12" v-show="formParam.header.ai_status == true
                                      ">
                                      <div class="row">
                                        <div class="col-md-6">
                                          <div class="form-group">
                                            <label>Sampaikan Pesan Saat Sesi
                                              Berakhir</label>
                                          </div>
                                        </div>
                                        <div class="col-md-2">
                                          <div class="onoffswitch">
                                            <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox"
                                              v-model="formParam.header.ai_close_status
                                                " id="switch_ai_close_status" />
                                            <label class="onoffswitch-label" for="switch_ai_close_status">
                                              <span class="onoffswitch-inner"></span>
                                              <span class="onoffswitch-switch"></span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-12" v-show="formParam.header.ai_status == true &&
                                      formParam.header.ai_close_status == true
                                      ">
                                      <div class="form-group">
                                        <label>Pesan Penutup</label>
                                        <textarea class="form-control" ref="messagebox-close-remarks"
                                          :style="'height:100px;'" v-model="formParam.header.ai_close_remarks
                                            "
                                          :placeholder="'Misalnya: Terima kasih sudah menghubungi kami. Jika ada pertanyaan lagi, jangan ragu untuk menghubungi kami kembali. Semoga harimu menyenangkan!! 😊🙏'"></textarea>
                                      </div>
                                    </div>
                                  </template>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-4 col-md-4">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="form-group form-focus select-focus">
                                    <select data-tour-step="formsar.6" v-model="formParam.header.frequency_per_person
                                      " class="form-control">
                                      <option v-for="(
row, idx
                                        ) in frequencyPerPersonList" :key="idx" :value="row.value">
                                        {{ row.label }}
                                      </option>
                                    </select>
                                    <label class="focus-label">Frequency per Person</label>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-md-12" v-show="false">
                                  <div class="form-group">
                                    <div class="form-group form-focus select-focus">
                                      <select data-tour-step="formsar.5" v-model="formParam.header.button_type"
                                        class="form-control">
                                        <!-- <option :value="''">-- Select --</option> -->
                                        <option v-for="(
row, idxBtn
                                          ) in interactiveMessageType" :key="idxBtn" :value="row.id">
                                          {{ row.label }}
                                        </option>
                                      </select>
                                      <label class="focus-label">Button Type</label>
                                    </div>
                                  </div>
                                </div>
                                <template v-if="
                                  formParam.header.button_type ==
                                  'text_reply' &&
                                  formParam.header.ai_status == false
                                ">
                                  <div class="col-12">
                                    <text-reply v-model="formParam" :isShowForm="isShowForm" />
                                  </div>
                                  <!-- <div
                                    v-for="index in defaultDetailTextReply"
                                    :key="index"
                                    class="col-md-12"
                                  >
                                    <div
                                      class="form-group form-focus select-focus"
                                    >
                                      <select
                                        @change="toggleDisability(this)"
                                        v-model="
                                          formParam.detail_button[index - 1]
                                            .auto_reply_button_id
                                        "
                                        class="form-control selectTextReply"
                                      >
                                        <option :value="''">
                                          -- Select --
                                        </option>
                                        <option
                                          v-for="(row, idxBtn) in textReplyRows"
                                          :ref="'text_reply_' + row.id"
                                          :key="idxBtn"
                                          :value="row.id"
                                        >
                                          {{ row.title }}
                                        </option>
                                      </select>
                                      <label class="focus-label"
                                        >Text Reply {{ index }}</label
                                      >
                                    </div>
                                  </div> -->
                                </template>
                                <template v-if="
                                  formParam.header.button_type == 'list_text'
                                ">
                                  <div v-for="index in defaultDetailListText" :key="index" class="col-md-12">
                                    <div class="form-group form-focus select-focus">
                                      <select v-model="formParam.detail_button[index - 1]
                                        .auto_reply_button_id
                                        " class="form-control">
                                        <option :value="''">
                                          -- Select --
                                        </option>
                                        <option v-for="(row, idxBtn) in buttonsRows" :key="idxBtn" :value="row.id">
                                          {{ row.button_title }}
                                        </option>
                                      </select>
                                      <label class="focus-label">List {{ index }}</label>
                                    </div>
                                  </div>
                                </template>
                                <template v-if="
                                  formParam.header.button_type == 'button'
                                ">
                                  <div v-for="index in defaultDetailButton" :key="index" class="col-md-12">
                                    <div class="form-group form-focus select-focus" v-if="index <= 3">
                                      <select v-model="formParam.detail_button[index - 1]
                                        .auto_reply_button_id
                                        " class="form-control">
                                        <option :value="''">
                                          -- Select --
                                        </option>
                                        <template v-for="(row, idxBtn) in buttonsRows">
                                          <option :key="idxBtn" :value="row.id">
                                            {{ row.button_title }}
                                          </option>
                                        </template>
                                      </select>
                                      <label class="focus-label">Button {{ index }}</label>
                                    </div>
                                  </div>
                                </template>
                                <template v-if="formParam.header.button_type == 'link'">
                                  <div v-for="index in defaultDetailButton" :key="index" class="col-md-12">
                                    <div class="form-group form-focus select-focus" v-if="index <= 3">
                                      <select v-model="formParam.detail_button[index - 1]
                                        .auto_reply_button_id
                                        " class="form-control">
                                        <option :value="''">
                                          -- Select --
                                        </option>
                                        <option v-for="(row, idxBtn) in linkRows" :key="idxBtn" :value="row.id">
                                          {{ row.button_title }}
                                        </option>
                                      </select>
                                      <label class="focus-label">Link/Call {{ index }}</label>
                                    </div>
                                  </div>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12" v-show="false">
                      <div class="form-group">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label data-tour-step="formsar.8">Enable Away Message</label>
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="onoffswitch">
                              <input type="checkbox" name="onoffswitch" v-model="formParam.header.is_enable_away_message_status
                                " class="onoffswitch-checkbox" id="is_enable_away_message" />
                              <label class="onoffswitch-label" for="is_enable_away_message">
                                <span class="onoffswitch-inner"></span>
                                <span class="onoffswitch-switch"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12" v-show="false">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                Start From
                                <select style="width: 50px" v-model="start_away_hour">
                                  <option :value="''">-- Select --</option>
                                  <option :value="'00'">00</option>
                                  <option v-for="hour in 23" :key="hour" :value="hour < 10 ? '0' + hour : hour">
                                    {{ hour < 10 ? "0" + hour : hour }} </option>
                                </select>

                                <select style="width: 50px" v-model="start_away_minute">
                                  <option :value="''">-- Select --</option>
                                  <option :value="'00'">00</option>
                                  <option v-for="minute in 59" :key="minute"
                                    :value="minute < 10 ? '0' + minute : minute">
                                    {{ minute < 10 ? "0" + minute : minute }} </option>
                                </select>
                                To
                                <select style="width: 50px" v-model="end_away_hour">
                                  <option :value="''">-- Select --</option>
                                  <option :value="'00'">00</option>
                                  <option v-for="hour in 23" :key="hour" :value="hour < 10 ? '0' + hour : hour">
                                    {{ hour < 10 ? "0" + hour : hour }} </option>
                                </select>
                                <select style="width: 50px" v-model="end_away_minute">
                                  <option :value="''">-- Select --</option>
                                  <option :value="'00'">00</option>
                                  <option v-for="minute in 59" :key="minute"
                                    :value="minute < 10 ? '0' + minute : minute">
                                    {{ minute < 10 ? "0" + minute : minute }} </option>
                                </select>

                                <i class="text-muted">Timezone in GMT+7 (Jakarta Time / WIB)</i>
                              </div>
                            </div>
                            <div class="col-sm-8 col-md-8">
                              <div class="form-group">
                                <label>
                                  Away Message:
                                  <span class="text-danger">*</span>
                                </label>
                                <!-- {{broadcastParam}} -->
                                <div class="message-bar">
                                  <div class="message-inner">
                                    <a class="link attach-icon" @click.prevent="emojiToggle2()">
                                      <img style="width: 30px" src="@/assets/emoji.png" alt />
                                    </a>
                                    <div class="message-area">
                                      <div class="input-group m-b-30">
                                        <div class="input-group-prepend">
                                          <div class="dropdown dropdown-action">
                                            <a href="#" class="action-icon dropdown-toggle text-info"
                                              data-toggle="dropdown" aria-expanded="false">
                                              <i class="material-icons">more_vert</i>
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                              <span style="margin: 5px">
                                                <b>
                                                  <u>Template Message:</u>
                                                </b>
                                              </span>
                                              <template v-for="temp in templateMessage">
                                                <a class="dropdown-item" @click.prevent="
                                                  addTemplateToMesage2(temp)
                                                  " :key="temp">{{ temp }}</a>
                                              </template>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="input-group-append">
                                          <Emoji :open="emojiAttr2.open" :width="emojiAttr2.width"
                                            :height="emojiAttr2.height" searchLabel="Search emoji here"
                                            @click="selectedEmoji2" />
                                        </div>
                                        <textarea v-on:keyup="countdownAway" :style="'height:150px;width:100%'"
                                          ref="messagebox" v-model="formParam.header.message_away
                                            " :placeholder="'Type message...'" required></textarea>
                                        <p class="text-right text-small" v-bind:class="{
                                          'text-danger': hasErrorAway,
                                        }">
                                          {{ remainingCountAway }}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-4 col-md-4" v-show="false">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="form-group">
                                    <label>Button Type</label>
                                    <div class="col-lg-9">
                                      <div style="display: none" class="form-check form-check-inline hidden">
                                        <input @click="resetDetailButtonAway" class="form-check-input" type="radio"
                                          v-model="formParam.header
                                            .button_type_away_message
                                            " id="button_away_message" value="button" />
                                        <label class="form-check-label" for="button_away_message">Button</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input @click="resetDetailButtonAway" v-model="formParam.header
                                          .button_type_away_message
                                          " class="form-check-input" type="radio" id="link_away_message"
                                          value="link" />
                                        <label class="form-check-label" for="link_away_message">
                                          Link/Call
                                          <i style="font-size: 10px" class="badge badge-danger">beta</i>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-12">
                                  <template v-if="
                                    formParam.header
                                      .button_type_away_message == 'button'
                                  ">
                                    <div v-for="index in defaultDetailButton" :key="index" class="col-md-12">
                                      <div class="form-group form-focus select-focus" v-if="index <= 3">
                                        <select v-model="formParam.detail_button_away[
                                          index - 1
                                        ].auto_reply_button_id
                                          " class="form-control">
                                          <option :value="''">
                                            -- Select --
                                          </option>
                                          <option v-for="(row, idxBtn) in buttonsRows" :key="idxBtn" :value="row.id">
                                            {{ row.button_title }}
                                          </option>
                                        </select>
                                        <label class="focus-label">Button {{ index }}</label>
                                      </div>
                                    </div>
                                  </template>
                                  <template v-if="
                                    formParam.header
                                      .button_type_away_message == 'link'
                                  ">
                                    <div v-for="index in defaultDetailButton" :key="index" class="col-md-12">
                                      <div class="form-group form-focus select-focus" v-if="index <= 3">
                                        <select v-model="formParam.detail_button_away[
                                          index - 1
                                        ].auto_reply_button_id
                                          " class="form-control">
                                          <option :value="''">
                                            -- Select --
                                          </option>
                                          <option v-for="(row, idxBtn) in linkRows" :key="idxBtn" :value="row.id">
                                            {{ row.button_title }}
                                          </option>
                                        </select>
                                        <label class="focus-label">Link/Call {{ index }}</label>
                                      </div>
                                    </div>
                                  </template>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12" v-show="false">
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label data-tour-step="formsar.9">Configure Footer Message</label>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="onoffswitch">
                            <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox"
                              v-model="formParam.header.footer_message_status" id="switch_footer_message" />
                            <label class="onoffswitch-label" for="switch_footer_message">
                              <span class="onoffswitch-inner"></span>
                              <span class="onoffswitch-switch"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12" v-if="formParam.header.footer_message_status == true">
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Footer Message:</label>
                            <input v-model="formParam.header.footer_message" placeholder="eq: Powered by Waajo.id"
                              type="text" class="form-control" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :class="tabMessage == 'preview' ? 'tab-pane show active' : 'tab-pane'
              " id="preview" :style="'background: url(\'' + whatsappBackground + '\');'">
              <preview-message :textReplyRows="textReplyRows" :buttonsRows="buttonsRows" :linkRows="linkRows" />
            </div>
          </div>

          <div class="submit-section">
            <div class="row">
              <div class="col-md-12" style="margin-bottom: 10px">
                <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
                  <li class="nav-item">
                    <a @click="settabMessage('setup')" :class="tabMessage == 'setup' ? 'nav-link active' : 'nav-link'
                      " href="#form" data-toggle="tab">Setup Message</a>
                  </li>
                  <li class="nav-item">
                    <a data-tour-step="formsar.10" @click="
                      savePreview();
                    settabMessage('preview');
                    " :class="tabMessage == 'preview' ? 'nav-link active' : 'nav-link'
                      " href="#preview" data-toggle="tab">Preview Message</a>
                  </li>
                </ul>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending == false">
                    <!-- {{isSending}} -->
                    <button @click="saveForm(0, 1)" class="btn btn-md btn-warning" type="button">
                      <i class="fa fa-save"></i> Draft
                    </button>

                    <button @click.prevent="saveForm(0, 0)" class="btn btn-md btn-success" type="button"
                      :style="'margin-left:10px;'">
                      <i class="fa fa-check"></i> Publish
                    </button>
                  </center>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending == false">
                    <button @click.prevent="saveForm(1, 0)" class="btn btn-lg btn-info" type="button">
                      <i class="fa fa-check"></i> Publish &amp; Exit
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-tour name="tourGuideSarForm" :steps="tourSteps" :callbacks="tourCallbacks"></v-tour>
  </div>
</template>

<script>
import { APICore, APICoreV2 } from "@/utils/servicesApi";
import { getXAuthAgent, getXAuthToken, getAgentSession } from "@/utils/auth";

import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";
import FileUpload from "vue-upload-component";
// import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";
import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";

import TextReply from '@/components/TextReply/index.vue';
import PreviewMessage from "./preview";
import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC,
} from "@/utils/helper";
export default {
  components: {
    Skeleton,
    FileUploadBc: FileUpload,
    FileUploadBcExtract: FileUpload,
    Emoji: VueChatEmoji,
    Multiselect,
    Datetime,
    PreviewMessage,
    TextReply
  },
  props: {
    searchData: {
      type: Function,
    },
    aiBalance: {
      type: Object,
    },
  },
  data() {
    return {
      maxCount: 1024,
      remainingCount: 1024,
      hasError: false,
      remainingCountAway: 1024,
      hasErrorAway: false,
      tourId: "sar.modalForm",
      tourCallbacks: {
        onSkip: this.tourComplete,
        onFinish: this.tourComplete,
      },
      tourSteps: [
        {
          target: '[data-tour-step="formsar.1"]', // We're using document.querySelector() under the hood
          content: `Lisensi atau Nomor Whatsapp pengirim. Pastikan nomor ini sudah discan dan terhubung dengan Waajo.`,
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="formsar.2"]',
          content:
            "Jika Kamu memilih kondisi trigger “All Incoming Chats“, maka seluruh chat/pesan yang dikirimkan oleh Customer akan memicu aktifnya fitur Smart Auto Reply.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="formsar.3"]',
          content:
            "Jika Kamu memilih trigger “Some Chats“, maka Kamu bisa mengatur kata atau kalimat apa saja yang bisa memicu fitur Smart Auto Reply.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="formsar.4"]',
          content: "Tempat untuk mengisi konten Smart Auto Reply.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="formsar.5"]',
          content:
            "Kamu bisa memilih Button yang akan ditampilkan bersamaan dengan Smart Auto Reply. Jadi pastikan Kamu sudah membuat Button & Replies.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="formsar.6"]',
          content: "Merupakan jeda waktu pengiriman Smart Auto Reply.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="formsar.7"]',
          content: "Kamu bisa menambahkan gambar pada Smart Auto Reply.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="formsar.8"]',
          content: "Kamu bisa mengaktifkan fitur Away Message pada bagian ini.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="formsar.9"]',
          content: " Fitur ini berguna untuk melakukan branding.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="formsar.10"]',
          content: "Untuk melihat tampilan pesan Auto Reply yang sudah dibuat.",
          params: {
            placement: "top",
          },
        },
      ],
      interactiveMessageType: [
        // { id: "button", label: "Button" },
        // { id: "link", label: "Link/Call" },
        { id: "text_reply", label: "Text Reply" },

        // { id: "list_text", label: "List" }
      ],
      tabMessage: "setup", //setup or preview
      whatsappBackground: process.env.VUE_APP_WHATSAPP_BACKGROUND,
      objFilesMessageHandler: {
        file: null,
        // message_media: messaegMedia,
        message_type: "",
      },
      messageTypeOptionsSupport: ["text only", "media"],
      uploadMessageSupportSelected: "text only",
      messageTypeOptionsUpload: ["image", "document"],
      uploadMessageType: "image",
      caption: "",
      name: "file",
      thumbUpload: [],
      uploadAuto: true,
      uploadUrl:
        // process.env.VUE_APP_BASE_API + this.APICore() + "/omni/room/send-file",
        process.env.VUE_APP_BASE_API +
        this.APICore() +
        "/omni/only-upload-filev2",
      maximumUpload: 1,
      accept: "image/jfif,image/png,image/gif,image/jpeg,image/webp",
      extensions: "jfif, gif,jpg,jpeg,png,webp,zip,pdf,xls,xlsx, doc, docx",
      objFilesMessageHandlerExtract: {
        file: null,
        message_type: "document",
        is_extract_document: 1,
      },
      acceptExtract:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/pdf",
      extensionsExtract: "pdf, doc, docx, pptx",
      filesExtract: [],

      minSize: 1024,
      size: 1024 * 1024 * 10,
      files: [],
      buttonsLoading: false,
      linkParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: "",
        },
        page: 1,
        perPage: 500, // perPage
      },
      buttonsParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: "",
        },
        page: 1,
        perPage: 500, // perPage
      },
      textReplyParams: {
        columnFilters: {
          title: "",
          is_publish: "publish",
        },
        page: 1,
        perPage: 500, // perPage
      },
      textReplyRows: [],
      buttonsRows: [],
      linkRows: [],
      selectedLicense: [],
      licenseOptions: [],
      licenseListParam: {
        id: "",
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20,
      },
      isLoadingLicense: false,
      emojiAttr2: {
        open: false,
        width: "0%",
        height: "0px",
      },
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px",
      },
      templateMessage: [
        "${first_name}",
        "${last_name}",
        "${phone_number}",
        "${email}",
        "${month_current}",
        "${month_current_name}",
        "${year_current}",
        "${today}",
        "${yesterday}",
        "${month_ago}",
        "${month_ago_name}",
        "${year_ago}",
      ],
      isSending: false,
      defaultDetailTextReply: 10,
      defaultDetailButton: 10,
      defaultDetailListText: 10, //max 10
      defaultDetailSome: 1,
      frequencyPerPersonList: [
        { value: 15, label: "Once per 15 Minutes" },
        { value: 30, label: "Once per 30 Minutes" },
        { value: 45, label: "Once per 45 Minutes" },
        { value: 60, label: "Once per 1 Hours" },
        { value: 1440, label: "Once per 1 Days" },
        { value: 4320, label: "Once per 3 Days" },
        { value: 10080, label: "Once per 7 Days" },
        { value: 20160, label: "Once per 14 Days" },
        { value: 43200, label: "Once per 30 Days" },
      ],
      frequencyCloseSessionList: [
        { value: 5, label: "5 Minutes" },
        { value: 10, label: "10 Minutes" },
        { value: 15, label: "15 Minutes" },
        { value: 30, label: "30 Minutes" },
        { value: 45, label: "45 Minutes" },
        { value: 60, label: "1 Hours" },
        { value: 1440, label: "1 Days" },
      ],
      aiTypeList: [
        { value: "freestyle", label: "Chat Completions" },
        { value: "summarize", label: "Knowledge Base" },
      ],
      start_away_hour: "19",
      start_away_minute: "00",
      end_away_hour: "07",
      end_away_minute: "00",
      someConditions: [
        {
          value: "start_with",
          label: "Start with",
        },
        {
          value: "end_with",
          label: "End with",
        },
        {
          value: "contains",
          label: "Contains",
        },
        {
          value: "not_contains",
          label: "Not Contains",
        },
      ],
      formParam: {
        header: {
          id: "",
          license_id: "",
          title: "",
          message: "",
          trigger_on: "all",
          trigger_on_some_type: "any",
          frequency_per_person: 15,
          is_enable_away_message: 0,
          is_enable_away_message_status: false,
          is_enable_attach_file: false,
          message_away: "",
          footer_message: "",
          footer_message_status: false,
          is_custom_url: false,
          image_url: "",
          message_type: "text",
          // button_type: "button",
          // button_type_away_message: "button"
          button_type: "text_reply",
          button_type_away_message: "text_reply",
          is_working_or_away: 0,
          is_working: 0,
          ai_status: false,
          ai_type: "summarize",
          ai_close_status: false,
          ai_loading: false,
          is_ai_create_summary: false,
          ai_close_frequency: 15,
          ai_close_remarks: "",
          ai_buttons: false,
          ai_prompt_system: "",
          ai_summary: "",
        },
        detail_button: [
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
        ],
        detail_button_away: [
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
          {
            auto_reply_button_id: "",
          },
        ],
        detail_some: [
          {
            select_variable: "conversation",
            condition: "start_with",
            text: "",
          },
        ],
        start_away: this.start_away_hour + ":" + this.start_away_minute,
        end_away: this.end_away_hour + ":" + this.end_away_minute,
      },
      isLoading: false,
    };
  },
  watch: {
    selectedLicense: {
      handler: function (val, oldVal) {
        // console.log("selectedLicense", val, oldVal);
        if (val.length > 1 && val != oldVal) {
          var that = this;
          setTimeout(function () {
            let lengthOld = oldVal.length;
            val.splice(0, 1);
            that.selectedLicense = val;
            that.formParam.header.license_id = val[0].id;
            return;
            // }
          }, 300);
        }

        // if (val != oldVal) {
        if (val.length == 1) {
          this.selectedLicense = val;
          this.formParam.header.license_id = val[0].id;
          return;
        }
        if (val != oldVal && oldVal.length == 1 && val.length < 1) {
          this.selectedLicense = [];
          this.formParam.header.license_id = "";
          return;
        }
      },
      deep: true,
    },
    isShowForm: {
      handler: function (val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          this.tourDetail();
          this.settabMessage("setup");
          this.selectedLicense = [];
          this.buttonsRows = [];
          this.linkRows = [];
          var that = this;
          // console.log("that.formParamSRSt",that.formParamSRSt)
          setTimeout(function () {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            if (
              that.formParamSRSt.header.id != "" &&
              that.formParamSRSt.header.id != null
            ) {
              if (
                typeof that.formParamSRSt.header.copy != "undefined" &&
                that.formParamSRSt.header.copy == true
              ) {
                that.formParamSRSt.header.id = "";
              }

              // console.log("that.formParamSRSt", that.formParamSRSt);
              that.formParam = that.formParamSRSt;
              that.formParam.header.frequency_per_person = parseInt(
                that.formParam.header.frequency_per_person
              );
              that.start_away_hour = that.formParam.header.start_away_hour;
              that.start_away_minute = that.formParam.header.start_away_minute;
              that.end_away_hour = that.formParam.header.end_away_hour;
              that.end_away_minute = that.formParam.header.end_away_minute;
              if (that.formParam.header.license_id != "") {
                that.asyncFindLicense("", that.formParam.header.license_id);
              }

              if (that.formParam.header.image_url != "") {
                that.formParam.header.is_enable_attach_file = true;
                that.uploadMessageType = that.formParam.header.message_type;
              } else {
                that.uploadMessageType = "image";
              }

              if (that.formParam.detail_some.length == 0) {
                {
                  that.formParam.detail_some.push({
                    select_variable: "conversation",
                    condition: "start_with",
                    text: "",
                  });
                }
              }

              if (
                that.formParam.header.button_type == "button" ||
                that.formParam.header.button_type == "link"
              ) {
                if (
                  that.formParam.detail_button.length < that.defaultDetailButton
                ) {
                  let kekuranganBtn =
                    that.defaultDetailButton -
                    that.formParam.detail_button.length;
                  if (that.formParam.header.button_type == "list_text") {
                    kekuranganBtn =
                      that.defaultDetailListText -
                      that.formParam.detail_button.length;
                  }
                  for (var i = 0; i < kekuranganBtn; i++) {
                    that.formParam.detail_button.push({
                      auto_reply_button_id: "",
                    });
                  }
                }
              } else {
                if (
                  that.formParam.detail_button.length <
                  that.defaultDetailListText
                ) {
                  let kekuranganBtn =
                    that.defaultDetailButton -
                    that.formParam.detail_button.length;
                  if (that.formParam.header.button_type == "list_text") {
                    kekuranganBtn =
                      that.defaultDetailListText -
                      that.formParam.detail_button.length;
                  }
                  for (var i = 0; i < kekuranganBtn; i++) {
                    that.formParam.detail_button.push({
                      auto_reply_button_id: "",
                    });
                  }
                }
              }

              if (
                that.formParam.detail_button_away.length <
                that.defaultDetailButton
              ) {
                let kekuranganBtnAway =
                  that.defaultDetailButton -
                  that.formParam.detail_button_away.length;
                for (var i = 0; i < kekuranganBtnAway; i++) {
                  that.formParam.detail_button_away.push({
                    auto_reply_button_id: "",
                  });
                }
              }

              // that.loadReplyButtons();
              that.loadTextReply();
              // that.loadReplyLink();
              // console.log("that.formParam", that.formParam);
            } else {
              that.asyncFindLicense("", "");
              that.loadTextReply();
              // that.loadReplyButtons();
              // that.loadReplyLink();
              that.formParam = {
                header: {
                  id: "",
                  license_id: "",
                  message: "",
                  trigger_on: "all",
                  trigger_on_some_type: "any",
                  frequency_per_person: 4320,
                  is_enable_away_message: 0,
                  message_away: "",
                  is_enable_attach_file: false,
                  is_custom_url: false,
                  image_url: "",
                  message_type: "text",
                  button_type: "text_reply",
                  button_type_away_message: "text_reply",
                  is_working_or_away: 0,
                  is_working: 0,
                  ai_status: false,
                  ai_type: "summarize",
                  ai_close_status: false,
                  ai_loading: false,
                  is_ai_create_summary: false,
                  ai_close_frequency: 15,
                  ai_close_remarks: "",
                  ai_buttons: false,
                  ai_prompt_system: "",
                  ai_summary: "",
                },
                detail_button: [
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                ],
                detail_button_away: [
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                  {
                    auto_reply_button_id: "",
                  },
                ],
                detail_some: [
                  {
                    select_variable: "conversation",
                    condition: "start_with",
                    text: "",
                  },
                ],
                start_away: that.start_away_hour + ":" + that.start_away_minute,
                end_away: that.end_away_hour + ":" + that.end_away_minute,
              };
            }
          }, 100);
        }
      },
      deep: true,
    },
  },
  computed: {
    headers() {
      return {
        "X-Auth-Token": "Bearer " + this.getXAuthToken(),
        // "X-Auth-Agent": "Bearer " + this.getXAuthAgent()
      };
    },
    ...mapGetters(["agentSession"]),
    formParamSRSt() {
      return this.$store.state.automation.formParamSRSt;
    },
    isShowForm() {
      return this.$store.state.automation.isShowForm;
    },
  },
  methods: {
    countdown: function () {
      this.remainingCount =
        this.maxCount - this.formParam.header.message.length;
      this.hasError = this.remainingCount < 0;
    },
    countdownAway: function () {
      this.remainingCountAway =
        this.maxCount - this.formParam.header.message_away.length;
      this.hasErrorAway = this.remainingCountAway < 0;
    },
    tourShow() {
      this.$tours["tourGuideSarForm"].start();
    },
    tourComplete() {
      let params = {};
      params = {
        tour_id: this.tourId,
      };
      this.$store.dispatch("tour/tourComplete", params);
    },
    tourDetail() {
      let params = {};
      params = {
        tour_id: this.tourId,
      };
      this.$store.dispatch("tour/tourDetail", params).then((response) => {
        var { data } = response;
        if (data.id == "") {
          this.tourShow();
        }
      });
    },
    settabMessage(value) {
      this.tabMessage = value;
    },
    addRow() {
      let newRow = {
        select_variable: "conversation",
        condition: "",
        text: "",
      };
      this.formParam.detail_some.push(newRow);
    },
    removeRow(removeIndex, maxIndex) {
      // console.log("removeIndex", removeIndex, maxIndex);
      if (removeIndex == 0 && maxIndex == 0) {
        return;
      }

      if (removeIndex > -1) {
        // only splice array when item is found
        this.formParam.detail_some.splice(removeIndex, 1); // 2nd parameter means remove one item only
      }
    },
    async loadTextReply() {
      this.buttonsLoading = await true;
      this.textReplyParams.page = 0;
      await this.$store
        .dispatch("automation/listTextReply", this.textReplyParams) // sesuai kan dengan method di API
        .then((response) => {
          const { data } = response;
          this.textReplyRows = data.data;
          this.buttonsLoading = false;
        })
        .catch((error) => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    toggleDisability(selectElement) { },
    async loadReplyButtons() {
      this.buttonsLoading = await true;
      this.buttonsParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyButtons", this.buttonsParams) // sesuai kan dengan method di API
        .then((response) => {
          const { data } = response;
          this.buttonsRows = data.data;
          this.buttonsLoading = false;
        })
        .catch((error) => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    resetDetailButton() {
      this.formParam.detail_button = [
        {
          auto_reply_button_id: "",
        },
        {
          auto_reply_button_id: "",
        },
        {
          auto_reply_button_id: "",
        },
        {
          auto_reply_button_id: "",
        },
        {
          auto_reply_button_id: "",
        },
        {
          auto_reply_button_id: "",
        },
        {
          auto_reply_button_id: "",
        },
        {
          auto_reply_button_id: "",
        },
        {
          auto_reply_button_id: "",
        },
        {
          auto_reply_button_id: "",
        },
      ];
    },
    resetDetailButtonAway() {
      this.formParam.detail_button_away = [
        {
          auto_reply_button_id: "",
        },
        {
          auto_reply_button_id: "",
        },
        {
          auto_reply_button_id: "",
        },
      ];
    },
    async loadReplyLink() {
      this.buttonsLoading = await true;
      this.linkParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyLink", this.linkParams) // sesuai kan dengan method di API
        .then((response) => {
          const { data } = response;
          this.linkRows = data.data;
          this.buttonsLoading = false;
        })
        .catch((error) => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabelLicense({ license_name, license_phone_number }) {
      if (typeof license_name != "undefined") {
        return `${license_name} – ${license_phone_number}`;
      }
    },
    asyncFindLicenseSelect(query) {
      this.licenseOptions = [];
      this.licenseListParam.license_name = query;
      this.licenseListParam.id = "";
      this.$store
        .dispatch("license/getLicenseList", this.licenseListParam)
        .then((response) => {
          // this.isLoadingLicense = false;
          this.licenseOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch((error) => {
          // this.isLoadingLicense = false;
        });
    },
    asyncFindLicense(query, id) {
      this.licenseListParam.license_name = query;
      if (typeof id != "undefined" && id != "") {
        this.licenseListParam.id = id;
      } else {
        this.licenseListParam.id = "";
      }
      this.$store
        .dispatch("license/getLicenseList", this.licenseListParam)
        .then((response) => {
          this.isLoadingLicense = false;
          this.licenseOptions = response.data.data;
          // console.log("licenseOptions", this.licenseOptions);
          if (
            typeof id != "undefined" &&
            id != "" &&
            this.licenseOptions.length > 0
          ) {
            this.selectedLicense = this.licenseOptions;
          }
        }) // sesuai kan dengan method di API
        .catch((error) => {
          this.isLoadingLicense = false;
        });
    },
    clearAllLicense() {
      this.selectedLicense = [];
    },
    addTemplateToMesage(template) {
      this.formParam.header.message += template;
    },
    addTemplateToMesage2(template) {
      this.formParam.header.message_away += template;
    },
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    },
    async savePreview() {
      this.formParam.header.message = await this.remove_tags(
        this.formParam.header.message
      );
      if (this.formParam.header.message_away != "") {
        this.formParam.header.message_away = await this.remove_tags(
          this.formParam.header.message_away
        );
      }
      await this.$store.dispatch("automation/actFormParamSRSt", this.formParam);
    },
    async saveForm(isExit = 0, isDraft = 0) {
      this.formParam.header.is_enable_away_message = 0;
      if (this.formParam.header.is_enable_away_message_status == true) {
        this.formParam.header.is_enable_away_message = 1;
      }
      if (this.hasError == true) {
        this.$fire({
          title: "Error Respond Message",
          text: "The maximum number of characters allowed is " + this.maxCount,
          type: "error",
          timer: 2000,
        }).then((r) => { });
        return;
      }
      if (this.hasErrorAway == true) {
        this.$fire({
          title: "Error Away Message",
          text: "The maximum number of characters allowed is " + this.maxCount,
          type: "error",
          timer: 2000,
        }).then((r) => { });
        return;
      }
      //jika away message enable maka kalkulasi start from and to
      if (this.formParam.header.is_enable_away_message == 1) {
        this.formParam.start_away =
          this.start_away_hour + ":" + this.start_away_minute;
        this.formParam.end_away =
          this.end_away_hour + ":" + this.end_away_minute;
      }

      if (this.formParam.header.footer_message_status == false) {
        this.formParam.header.footer_message = ""; //data dihapus
      }

      if (typeof isDraft == "undefined") {
        this.formParam.header.is_publish = 1;
      } else {
        if (isDraft == 1) {
          this.formParam.header.is_publish = 0;
        } else {
          this.formParam.header.is_publish = 1;
        }
      }

      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`,
      }).then(async (r) => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          // console.log("valueee", r);
          this.isSending = await true;
          this.emojiToggle(false);
          this.emojiToggle2(false);
          this.formParam.header.message = await this.remove_tags(
            this.formParam.header.message
          );
          if (this.formParam.header.message_away != "") {
            this.formParam.header.message_away = await this.remove_tags(
              this.formParam.header.message_away
            );
          }
          this.formParam.header.is_working_or_away = 0;
          this.formParam.header.is_working = 0;
          this.formParam.header.network_id = parseInt(
            this.formParam.header.network_id
          );
          this.formParam.header.create_datetime = parseInt(
            this.formParam.header.create_datetime
          );
          this.formParam.header.update_datetime = parseInt(
            this.formParam.header.update_datetime
          );
          this.formParam.header.ai_close_frequency = parseInt(
            this.formParam.header.ai_close_frequency
          );

          if (this.formParam.header.ai_status == false) {
            this.formParam.header.ai_status = 0;
            this.formParam.header.ai_buttons = 0;
            this.formParam.header.ai_close_status = 0;
            this.formParam.header.ai_loading = 0;
            this.formParam.header.is_ai_create_summary = 0;
          } else {
            this.formParam.header.ai_status = 1;
          }

          if (this.formParam.header.ai_close_status == true) {
            this.formParam.header.ai_close_status = 1;
          } else {
            this.formParam.header.ai_close_status = 0;
          }
          if (this.formParam.header.ai_loading == true) {
            this.formParam.header.ai_loading = 1;
          } else {
            this.formParam.header.ai_loading = 0;
          }
          if (this.formParam.header.is_ai_create_summary == true) {
            this.formParam.header.is_ai_create_summary = 1;
          } else {
            this.formParam.header.is_ai_create_summary = 0;
          }
          if (this.formParam.header.ai_buttons == true) {
            this.formParam.header.ai_buttons = 1;
          } else {
            this.formParam.header.ai_buttons = 0;
          }

          await this.$store
            .dispatch("automation/storeSmartReply", this.formParam)
            .then((response) => {
              // this.isSending = false;
              if (this.formParam.id == "") {
                this.formParam = {
                  header: {
                    id: "",
                    title: "",
                    license_id: "",
                    message: "",
                    trigger_on: "all",
                    trigger_on_some_type: "any",
                    frequency_per_person: 4320,
                    is_enable_away_message: 0,
                    is_enable_away_message_status: false,
                    is_enable_attach_file: false,
                    message_away: "",
                    footer_message: "",
                    footer_message_status: false,
                    is_custom_url: false,
                    image_url: "",
                    button_type: "link",
                    button_type_away_message: "link",
                    is_working_or_away: 0,
                    is_working: 0,
                    ai_status: false,
                    ai_type: "summarize",
                    ai_close_status: false,
                    ai_loading: false,
                    is_ai_create_summary: false,
                    ai_close_frequency: 15,
                    ai_close_remarks: "",
                    ai_buttons: false,
                    ai_prompt_system: "",
                    ai_summary: "",
                  },
                  detail_button: [
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                  ],
                  detail_button_away: [
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                    {
                      auto_reply_button_id: "",
                    },
                  ],
                  detail_some: [],
                  start_away:
                    this.start_away_hour + ":" + this.start_away_minute,
                  end_away: this.end_away_hour + ":" + this.end_away_minute,
                };
              }

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000,
              }).then((r) => { });
              this.searchData();
              if (isExit == 1) {
                var elem = this.$refs.dismisModal;
                elem.click();
              }
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    },
    remove_tags(html) {
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      this.formParam.header.message += args.emoji;
      // console.log(args); /* return {...}*/
    },
    emojiToggle2(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr2.open == true) {
          this.emojiAttr2.open = false;
        } else {
          this.emojiAttr2.open = true;
        }
      } else {
        this.emojiAttr2.open = isClosed;
      }

      if (this.emojiAttr2.open == true) {
        this.emojiAttr2.width = "96%";
        this.emojiAttr2.height = "250px";
      } else {
        this.emojiAttr2.width = "0%";
        this.emojiAttr2.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji2(args) {
      this.formParam.header.message_away += args.emoji;
      // console.log(args); /* return {...}*/
    },

    updateMessageSupportCurrent(msgType) {
      this.uploadMessageSupportSelected = msgType;
    },
    forceDisableAttachFile() {
      this.formParam.header.is_enable_attach_file = false;
      //this.updateMessageTypeCurrent("")
    },
    updateMessageTypeCurrent(msgType) {
      if (msgType == "") {
        var that = this;
        setTimeout(function () {
          // console.log(
          //   "that.formParam.header.is_enable_attach_file",
          //   that.formParam.header.is_enable_attach_file
          // );
          if (that.formParam.header.is_enable_attach_file == true) {
            that.formParam.header.message_type = "image";
            that.uploadMessageType = that.formParam.header.message_type;
            // that.formParam.header.is_custom_url = false;
            // console.log("that.uploadMessageTyp",that.uploadMessageType)
          } else {
            that.formParam.header.message_type = "text";
          }
        }, 100);
      } else {
        this.uploadMessageType = msgType;
        this.formParam.header.message_type = msgType;
      }
    },
    inputFileHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.$refs.uploadbc.active = true;
        // console.log("xxx",inputFileHandler)
      }
    },
    inputFilterExtract(newFile, oldFile, prevent) {
      console.log("newFile, oldFile", newFile, oldFile);
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    inputFileExtract(newFile, oldFile) {
      // console.log("inputFile:oldddd", oldFile);
      // console.log("inputFile:newf", newFile);
      if (newFile && oldFile) {
        console.log("oldddd", oldFile);
        console.log("newf", newFile);
        // update
        if (newFile.active && !oldFile.active) {
          //buildData
          let dataArr = {
            message_type: "document",
            is_extract_document: 1,
          };
          // this.$store.dispatch("omniwa/actFilesMessageHandler", dataArr);
          this.objFilesMessageHandlerExtract = dataArr;
          this.$refs.uploadbcExtract.update(newFile, { data: dataArr });

          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.uploadbcExtract.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
          console.log("progress", newFile.progress);
        }
        if (newFile.error && !oldFile.error) {
          console.log("err", newFile.error.response);
          console.log("newFile", newFile);
          this.$refs.uploadbcExtract.update(newFile, { progress: 0 });

          // error
          this.$fire({
            title: "Error",
            text: newFile.response.msg,
            type: "error",
            timer: 1000,
          }).then((r) => { });
        }
        if (newFile.success && !oldFile.success) {
          // this.formParam.header.image_url = newFile.response.data.url;
          this.formParam.header.ai_summary = newFile.response.data.text_value;
          if (newFile.response.data.text_error) {
            this.$fire({
              title: "Error",
              text: newFile.response.data.text_error,
              type: "error",
              timer: 1000,
            }).then((r) => { });
          }
          this.caption = "";
          // success
          // console.log("this.thumbUpload", this.thumbUpload);
          console.log("success", newFile.success, newFile);
        }
      }
      if (!newFile && oldFile) {
        // this.formParam.header.image_url = "";
        // this.formParam.header.ai_summary = "";

        // remove
        if (oldFile.success && oldFile.response.id) {
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.uploadbcExtract.active) {
          this.$refs.uploadbcExtract.active = true;
        }
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      console.log("newFile, oldFile", newFile, oldFile);
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }

        // var liContainer = document.getElementById("drag_files");
        // var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal",isShowModal)
        // if (isShowModal == false) {
        //   // document.getElementById("btnDragFiles").click(); // Click on the checkbox
        // }
        // Automatic compression
        // 自动压缩
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          // console.log("compressing", newFile, oldFile);

          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512,
          });
          imageCompressor
            .compress(newFile.file)
            .then((file) => {
              this.$refs.uploadbc.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type,
              });
            })
            .catch((err) => {
              this.$refs.uploadbc.update(newFile, {
                error: err.message || "compress",
              });
            });
        }
      }
      console.log("humb newFile, oldFile: ", newFile, oldFile);
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
      // image size
      // image 尺寸
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.substr(0, 6) === "image/" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        newFile.error = "image parsing";
        let img = new Image();
        img.onload = () => {
          this.$refs.uploadbc.update(newFile, {
            error: "",
            height: img.height,
            width: img.width,
          });
        };
        img.οnerrοr = (e) => {
          console.log("errorr", e);
          this.$refs.uploadbc.update(newFile, { error: "parsing image size" });
        };
        img.src = newFile.blob;
      }
    },
    inputFile(newFile, oldFile) {
      // console.log("inputFile:oldddd", oldFile);
      // console.log("inputFile:newf", newFile);
      if (newFile && oldFile) {
        console.log("oldddd", oldFile);
        console.log("newf", newFile);
        // update
        if (newFile.active && !oldFile.active) {
          //buildData
          let dataArr = {
            message_type: this.uploadMessageType,
          };
          // this.$store.dispatch("omniwa/actFilesMessageHandler", dataArr);
          this.objFilesMessageHandler = dataArr;
          this.$refs.uploadbc.update(newFile, { data: dataArr });

          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.uploadbc.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
          console.log("progress", newFile.progress);
        }
        if (newFile.error && !oldFile.error) {
          console.log("err", newFile.error.response);
          console.log("newFile", newFile);
          this.$refs.uploadbc.update(newFile, { progress: 0 });

          // error
          this.$fire({
            title: "Error",
            text: newFile.response.msg,
            type: "error",
            timer: 1000,
          }).then((r) => { });
        }
        if (newFile.success && !oldFile.success) {
          this.formParam.header.image_url = newFile.response.data.url;
          this.caption = "";
          this.thumbUpload.push(newFile.thumb);
          // success
          // console.log("this.thumbUpload", this.thumbUpload);
          console.log("success", newFile.success, newFile);
        }
      }
      if (!newFile && oldFile) {
        this.formParam.header.image_url = "";
        // remove
        if (oldFile.success && oldFile.response.id) {
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.uploadbc.active) {
          this.$refs.uploadbc.active = true;
        }
      }
    },
    formatSizes(bytes) {
      return formatSizes(bytes);
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    getXAuthToken() {
      return getXAuthToken();
    },
    getXAuthAgent() {
      return getXAuthAgent();
    },
    getWhatsappNumberFromJid(jid) {
      return getWhatsappNumberFromJid(jid);
    },
    APICoreV2() {
      return APICoreV2();
    },
    APICore() {
      return APICore();
    },
  },
  async created() { },
  beforeDestroy() { },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left",
        },
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add",
};
</script>


// WEBPACK FOOTER //
// src/views/automation/welcomeChat/form.vue